'use strict';

require('./index').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/es6-object-assign/auto.js
// module id = 2568
// module chunks = 0